module.exports = __webpack_public_path__ + "static/img/new_build.3475451.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_build.jpeg
// module id = GtDq
// module chunks = 0